/* External Imports */
import { useState } from 'react';

/* Built In Imports */
import { Box, Divider, Step, Stepper, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import LazyImageRenderComponent from '@components/UI/LazyImageRenderComponent';


/**
 * @param {Object} sectionContent
 * @param {String} lang
 * @param {String} region
 * @returns
 */

const SnapshotJourney = ({ region, lang, sectionContent, pageConfig }) => {
  const pageConfigVal = pageConfig?.[0]?.value;

  function findField(fieldId) {
    const data = sectionContent.find(el => el._modelApiKey === fieldId);
    return data;
  }
  const [activeStep, setActiveStep] = useState(0); // Track the active step
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const programHeading = sectionContent?.find(
    e => e.fieldId === 'journey-heading'
  );

  const cards = findField('card_circular2_column_group')?.cards || [];
  //"section_title"
  return (
    <Box
      bgImage={{
        base: pageConfigVal?.waveOfBliss?.bgImage?.mob,
        md: pageConfigVal?.waveOfBliss?.bgImage?.tab,
        lg: pageConfigVal?.waveOfBliss?.bgImage?.desktop,
        xl: pageConfigVal?.waveOfBliss?.bgImage?.bigScreen,
      }}
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      pt={{ base: '49px', md: '80px', lg: '120px' }}
      pb={{ base: '0px', md: '0px' }}
      px={'16px'}
      borderRadius="lg"
      color={'#525252'}
      mx="auto"
    >
      <StructuredTextParser
        str={findField('section_title')?.titleText}
        fontSize={{ base: '32px', md: '64px' }}
        lineHeight={{ base: '38px', md: '64px' }}
        fontFamily="FedraSansStd-medium"
        textAlign={{ base: 'start', md: 'center' }}
        mb={{ base: '21px', md: '20px' }}
        mt={{ base: '0', md: '0px' }}
        mx="auto"
        maxW={{ base: '615px' }}
      />
      <StructuredTextParser
        str={render(sectionContent?.[1]?.body)}
        fontSize={{ base: '16px', md: '24px' }}
        lineHeight={{ base: '24px', md: '31px' }}
        fontFamily="FedraSansStd-book"
        textAlign={{ base: 'start', md: 'center' }}
        maxW={{ base: '1006px' }}
        mb={{ base: '32px', md: '40px' }}
        mt={{ base: '0', md: '0px' }}
        mx="auto"
        className="heading_box"
      />
      {/* Heading */}
      {programHeading && (
        <StructuredTextParser
          str={render(programHeading?.body)}
          fontSize={{ base: '26px', md: '34px' }}
          lineHeight={{ base: '34px', md: '44px' }}
          fontFamily="FedraSansStd-medium"
          textAlign={{ base: 'start', md: 'center' }}
          maxW={{ base: '100%', md: '70%' }}
          mb={{ base: '31px', md: '60px' }}
          mt={{ base: '0', md: '0px' }}
          mx="auto"
          className="heading_box"
        />
      )}
      {/* Stepper  */}
      {!isMobile ? (
        <Stepper
          index={activeStep}
          onStepClick={index => setActiveStep(index)}
          colorScheme="teal"
          size="lg"
          orientation="vertical"
          display="flex"
          alignItems="center"
          justifyContent="center"
          maxWidth={{ md: '750px', lg: '920px' }}
          mx="auto"
          gap="0"
        >
          {cards?.map((list, index) => (
            <>
              {index % 2 === 0 ? (
                <Step key={list.title}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-evenly"
                    width={{ md: '750px', lg: '920px' }}
                  >
                    <Box
                      pt={index === 0 ? '32px' : '58px'}
                      pb={index === cards?.length - 1 ? '32px' : '58px'}
                      width="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-end"
                    >
                      <LazyImageRenderComponent
                        pr="55px"
                        src={list?.thumbnail?.url}
                        alt={list?.thumbnail?.alt}
                      />
                    </Box>

                    <Box width="4px" height="100%">
                      <Divider
                        orientation="vertical"
                        height="100%"
                        width="100%"
                        borderLeftWidth={'4px'}
                        borderColor={
                          activeStep === index ? '#F37021' : '#F1EBDF'
                        }
                      />
                    </Box>
                    <Box
                      pt={index === 0 ? '32px' : '58px'}
                      pb={index === cards?.length - 1 ? '32px' : '58px'}
                      width="100%"
                      pl={'55px'}
                    >
                      <Text
                        color="#11146E"
                        fontSize={'36px'}
                        lineHeight={'47px'}
                        fontFamily="FedraSansStd-medium"
                        mb={'18px'}
                      >
                        {list?.title}
                      </Text>
                      <StructuredTextParser
                        str={render(list?.description?.value)}
                        color="#525252"
                        fontSize={'26px'}
                        lineHeight={'34px'}
                        fontFamily="FedraSansStd-book"
                        className="detailText"
                      />
                    </Box>
                  </Box>
                </Step>
              ) : (
                <Step key={list.title}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-evenly"
                    width={{ md: '750px', lg: '920px' }}
                  >
                    <Box
                      pt={index === 0 ? '32px' : '58px'}
                      pb={index === cards?.length - 1 ? '32px' : '58px'}
                      width="100%"
                      textAlign="right"
                    >
                      <Box mr="55px">
                        <Text
                          color="#11146E"
                          fontSize="30px"
                          lineHeight="38.92px"
                          fontFamily="FedraSansStd-medium"
                          mb="16px"
                          mr="8px"
                        >
                          {list?.title}
                        </Text>
                        <StructuredTextParser
                          str={render(list?.description?.value)}
                          color="#525252"
                          fontSize={'26px'}
                          lineHeight={'34px'}
                          fontFamily="FedraSansStd-book"
                          className="detailText"
                          textAlign="right"
                        />
                      </Box>
                    </Box>

                    <Box width="4px" height="100%">
                      <Divider
                        orientation="vertical"
                        height="100%"
                        width="100%"
                        borderLeftWidth={'4px'}
                        borderColor={
                          activeStep === index ? '#F37021' : '#F1EBDF'
                        }
                      />
                    </Box>
                    <Box
                      pt={index === 0 ? '32px' : '58px'}
                      pb={index === cards?.length - 1 ? '32px' : '58px'}
                      pl={'55px'}
                      width="100%"
                      display="flex"
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <LazyImageRenderComponent
                        src={list?.thumbnail?.url}
                        alt={list?.thumbnail?.alt}
                      />
                    </Box>
                  </Box>
                </Step>
              )}
            </>
          ))}
        </Stepper>
      ) : (
        <Stepper
          index={activeStep}
          onStepClick={index => setActiveStep(index)}
          colorScheme="teal"
          size="lg"
          orientation="vertical"
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap="0"
        >
          {cards.map((list, index) => (
            <Step key={list.step}>
              <Box
                display="flex"
                alignItems="start"
                justifyContent="space-evenly"
              >
                <Box width="14px" height="100%">
                  <Divider
                    orientation="vertical"
                    height="100%"
                    width="100%"
                    borderLeftWidth={'3px'}
                    borderColor={activeStep === index ? '#F37021' : '#F1EBDF'}
                  />
                </Box>
                <Box
                  pt={index === 0 ? '12px' : '22px'}
                  pb={index === cards?.length - 1 ? '12px' : '22px'}
                  maxW={{ base: '80px', sm: '100px', md: '100%' }}
                  minW={{ base: '80px', sm: '100px', md: '100%' }}
                >
                  <LazyImageRenderComponent
                    pr="16px"
                    src={list?.thumbnail?.url}
                    alt={list?.thumbnail?.alt}
                    w="140px"
                  />
                </Box>

                <Box
                  pt={index === 0 ? '12px' : '22px'}
                  pb={index === cards?.length - 1 ? '12px' : '22px'}
                  width="100%"
                >
                  <Text
                    color="#11146E"
                    fontSize="18px"
                    lineHeight="28px"
                    fontFamily="FedraSansStd-medium"
                    mb="8px"
                  >
                    {list?.title}
                  </Text>
                  <StructuredTextParser
                    str={render(list?.description?.value)}
                    color="#525252"
                    fontSize="16px"
                    lineHeight="21px"
                    fontFamily="FedraSansStd-book"
                    className="detailText"
                    mt="0px"
                  />
                </Box>
              </Box>
            </Step>
          ))}
        </Stepper>
      )}

      <style>{`
      .detailText strong{
      color: #F37021;
      }
        .heading_box h2{
          color:#F37021
          }
          .heading_box mark{
            background: none;
            color:#12166F
          }
      `}</style>
    </Box>
  );
};
export default SnapshotJourney;
